import Container from '@/components/atoms/Container'
import Icon from '@/components/atoms/Icon'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'
import LinkManager from '@/utils/helpers/LinkManager'
import { HomeCourseList } from './Home'
import useIsCurrentLink from '@/utils/hooks/useIsCurrentLink'
import { LibraryList } from './Library'

export function List() {
	const { pathname } = useLocation()

	const baseUrl = '/curso'
	const linkManager = new LinkManager(baseUrl)

	function createLink(to: string) {
		return linkManager.create(to)
	}

	function useIsCurrentLink_(to: string) {
		return !!useIsCurrentLink(createLink(to))
	}

	const navItens = [
		{
			label: 'Visão Geral',
			link: createLink('/'),
			current: useIsCurrentLink_('/'),
			iconStroke: true,
		},
		{
			label: 'Biblioteca',
			link: createLink('/biblioteca'),
			current: useIsCurrentLink_('/biblioteca'),
			iconStroke: true,
		},
	]

	const components = {
		[createLink('/')]: <HomeCourseList />,
		[createLink('/biblioteca')]: <LibraryList />,
	}

	return (
		<Container className='py-10'>
			<div className='flex gap-3'>
				{navItens?.map((item, key) => {
					return (
						<Link
							key={key}
							to={item.link}
							className={twMerge(
								'flex items-center gap-2 py-2 px-3 font-semibold leading-none text-zinc-50 opacity-80 hover:opacity-100 transition-opacity',
								classNames({
									'opacity-100 bg-brand-primary text-white rounded-lg':
										item.current,
								})
							)}
						>
							<Icon
								name={item.label}
								width='22'
								height='22'
								fill='currentColor'
								className={twMerge(
									'text-white',
									classNames({
										'stroke-white': item.iconStroke,
										'text-white': item.current,
									})
								)}
							/>
							{item.label}
						</Link>
					)
				})}
			</div>

			{components[pathname]}
		</Container>
	)
}
